/**
 * @deprecated
 */

import $ from 'jquery';

// export to window
window.$ = $;
window.jQuery = $;




// WEBPACK FOOTER //
// ./fe/web-default/src/js/windowExports.js